var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor",class:_vm.classDivObject},[_vm._t("default",function(){return [_c('Sp',{attrs:{"span":"","class-object":['text-h5', 'font-weight-bold', 'ml-5', 'float-left']},on:{"onClick":_vm.onTitleClick}},[_vm._v(_vm._s(_vm.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }